<template>
	<div class="goods">
		<!--顶部搜索框 -->
		<div class="nav">
			<van-icon name="arrow-left" size="1.2rem" color="#fff" @click="back" />
			<van-col span="24">
				<van-search class="special_serch" v-model="value" @focus="serch" placeholder="您喜欢的" shape="round" background="#f1452f" />
			</van-col>
		</div>
		<!-- 综合列表 -->
		<van-row class="dropdown">
			<van-col span="5" @click="toggTab(1)" :class="{active : flag==1}">
				<span class="esp">综合</span>
			</van-col>
			<van-col span="5" @click="toggle" :class="{active : flag==5 || flag==6}">
				<div class="esp">
					<span>价格</span>
					<img v-if="flag==5" src="../../assets/up.png" alt="">
					<img v-else-if="flag==6" src="../../assets/down.png" alt="">
					<img v-else src="../../assets/default.png" alt="">
				</div>
			</van-col>
			<van-col span="5" @click="toggTab(7)" :class="{active : flag==7}">
				<span class="esp">销量</span>
			</van-col>
			<van-col span="5" @click="show=true" :class="{active : show==true}">
				<span class="esp">筛选</span>
			</van-col>
			<van-popup v-model="show" close-on-click-overlay position="right" :style="{ height: '100%', width: '85%' }">
				<div class="popup-top">
					<van-panel title="购买方式">
						<van-row type="flex" justify="space-around">
							<van-col :class="{'popup-active': category_id==1}" @click="category_id=1" span="6">品牌租赁
							</van-col>
							<van-col :class="{'popup-active': category_id==2}" @click="category_id=2" span="6">特价销售
							</van-col>
							<van-col :class="{'popup-active': category_id==3}" @click="category_id=3" span="6">精品二手
							</van-col>
						</van-row>
					</van-panel>
				</div>
				<div class="popup-bottom">
					<div>
						<van-panel title="风格">
							<van-row class="screen_brand">
								<van-col v-for="(item,index) in screen_brand.style" :class="{'popup-active': style_id==item.id}" @click="style_id==item.id ? style_id = '' : style_id=item.id">{{item.title}}
								</van-col>
							</van-row>
						</van-panel>
						<van-panel title="分类">
							<van-row class="screen_brand">
								<van-col v-for="(item,index) in screen_brand.category" :class="{'popup-active': cat_id==item.id}" @click="cat_id==item.id ? cat_id = '' : cat_id=item.id">{{item.title}}</van-col>
							</van-row>
						</van-panel>
						<van-panel title="品牌">
							<van-row class="screen_brand">
								<van-col v-for="(item,index) in screen_brand.brand" :class="{'popup-active': brand_id==item.id}" @click="brand_id==item.id ? brand_id = '' : brand_id=item.id">{{item.title}}
								</van-col>
							</van-row>
						</van-panel>
					</div>
				</div>
				<div class="popup-btn">
					<van-button round size="small" type="default" @click="reset">重置</van-button>
					<van-button color="#f1452f" round size="small" type="info" @click="submit">确定</van-button>
				</div>
			</van-popup>
		</van-row>
		<!--商品列表 -->
		<div v-if="this.none" class="none">暂无数据</div>
		<van-list v-model="loading" :offset="offset" :finished="finished" :immediate-check="immediate_check" finished-text="我是有底线的"
		 @load="onLoad" v-else>
			<!-- 瀑布流 -->
			<ul class="left-waterfall" ref="left">
				<li class="item" v-for="(item, index) in leftItems" @click="setParams(item.id)">
					<img :src="item.image | handleUrl" alt="">
					<div class="main">
						<p>{{item.title}}</p>
						<div class="vangrid-right">
							<span class="f1452f" v-if="item.category_id == 1">
								<span>租金</span>
								<span class="font-5">{{Number(item.price).toFixed(2).split(".")[0]}}</span>.{{Number(item.price).toFixed(2).split(".")[1]}}/月起
							</span>
							<span class="f1452f font-5" v-else>¥{{item.price}}</span>
							<van-icon name="shopping-cart-o" size="14px" color="#fff" v-if="item.category_id==1" />
						</div>
						<div class="vangrid-bottom" v-if="item.category_id==1">
							<div v-if="item.category_id==1">
								<span v-if="item.goods_work == 7">工期7-10天</span>
								<span v-if="item.goods_work == 15">工期15-20天</span>
								<span v-if="item.goods_work == 30">工期30-40天</span>
								<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="item.hot_num" readonly />
							</div>
						</div>
					</div>
				</li>
			</ul>
			<ul class="right-waterfall" ref="right">
				<li class="item" v-for="(item, index) in rightItems" @click="setParams(item.id)">
					<img :src="item.image | handleUrl" alt="">
					<div class="main">
						<p>{{item.title}}</p>
						<div class="vangrid-right">
							<span class="f1452f" v-if="item.category_id == 1">
								<span>租金￥</span>
								<span class="font-5">{{Number(item.price).toFixed(2).split(".")[0]}}</span>.{{Number(item.price).toFixed(2).split(".")[1]}}/月起
							</span>
							<span class="f1452f font-5" v-else>¥{{item.price}}</span>
							<van-icon name="shopping-cart-o" size="14px" color="#fff" v-if="category_id==1" />
						</div>
						<div class="vangrid-bottom">
							<div v-if="item.category_id==1">
								<span v-if="item.goods_work == 7">工期7-10天</span>
								<span v-if="item.goods_work == 15">工期15-20天</span>
								<span v-if="item.goods_work == 30">工期30-40天</span>
								<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="item.hot_num" readonly />
							</div>
						</div>
					</div>
				</li>
			</ul>
			<div style="clear:both"></div>
		</van-list>
	</div>
</template>

<script>
	import Footbar from '@/components/footbar';

	export default {
		name: 'pages',
		data() {
			return {
				loading: false,
				finished: false,
				none: false,
				offset: 0,
				immediate_check: false,
				flag: 1, //导航条件
				show: false,
				//商品列表
				goods: [],
				leftItems: [],
				rightItems: [],
				brand: [],
				page: 1,
				value: '',
				screen_brand: [],
				style_id: '',
				cat_id: '',
				brand_id: ''
			}
		},
		created() {
			if (this.$route.query.category_id) {
				this.category_id = this.$route.query.category_id
			}
			if (this.$route.query.cat_id) {
				this.cat_id = this.$route.query.cat_id
			}
			this.getTitle();
			//加载筛选条件
			this.$axios.post(baseUrl + '/mobile/Category/goodsCategory').then((res) => {
				if (res.data.code == 2) {
					this.screen_brand = res.data.data;
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		methods: {
			// 数据左右布局
			updateWaterfall() {
				const leftHeight = this.leftItems.length
				const rightHeight = this.rightItems.length
				let item = this.goods.shift();
				if (item == null) {
					return
				}
				if (item != undefined) {
					if (leftHeight <= rightHeight) {
						this.leftItems.push(item)
					} else {
						this.rightItems.push(item)
					}
					this.$nextTick(function() {
						this.updateWaterfall()
					})
				}
			},

			//获取title列表
			getTitle() {
				//初始化数据列表
				this.$axios.post(baseUrl + '/mobile/Goods/goodsShow', {
					title: this.value,
					page: this.page,
					limit: 10,
					order: this.flag,
					category_id: this.category_id,
					style_id: this.style_id,
					cat_id: this.cat_id,
					brand_id: this.brand_id
				}).then((res) => {
					if (res.data.code == 2) {
						this.page = 2;
						this.none = false;
						this.goodsShow();
						this.goods = res.data.data;
						this.updateWaterfall();
					} else {
						this.none = true;
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			// 异步更新数据
			onLoad() {
				this.$axios.post(baseUrl + '/mobile/Goods/goodsShow', {
					title: this.value,
					page: this.page,
					limit: 10,
					order: this.flag,
					category_id: this.category_id,
					style_id: this.style_id,
					cat_id: this.cat_id,
					brand_id: this.brand_id
				}).then((res) => {
					if (res.data.code == 2) {
						this.page++;
						setTimeout(() => {
							for (var i in res.data.data) {
								this.goods.push(res.data.data[i])
							}
							// 加载状态结束
							this.loading = false;
							this.updateWaterfall()
						}, 500)
					} else {
						this.loading = false;
						this.finished = true;
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			//条件切换
			toggTab(fa) {
				this.flag = fa;
				this.page = 1;
				this.getTitle();
			},
			//价格切换
			toggle() {
				if (this.flag != 5) {
					this.flag = 5
				} else if (this.flag == 5) {
					this.flag = 6
				}
				this.page = 1;
				this.getTitle();
			},
			//切换导航数据
			goodsShow() {
				this.finished = false;
				this.leftItems = [];
				this.rightItems = [];
			},
			//跳转详情页
			setParams(em) {
				this.$router.push({
					path: '/Detail',
					query: {
						id: em
					}
				})
			},
			//提交筛选条件
			submit() {
				this.page = 1;
				this.show = false;
				this.getTitle();
			},
			//重置
			reset() {
				this.category_id = 1;
				this.style_id = '';
				this.cat_id = '';
				this.brand_id = '';
			}
		},
	}
</script>

<style scoped>
	@import 'pages.css';

	.goods .none {
		font-size: 0.8rem;
		color: #B0B0B0;
		margin-top: 5rem;
	}

	.vangrid-bottom .van-rate {
		position: relative;
		top: 0.15rem;
	}

	.vangrid-bottom div {
		display: flex;
		justify-content: space-between;
	}

	.goods .dropdown {
		position: fixed;
		width: 100%;
		background: #fff;
		z-index: 999;
	}

	.goods .van-list {
		padding-top: 3rem;
	}

	.xuanzhong_he {
		justify-content: space-between;
		display: flex;
	}

	.goods .van-list .main .vangrid-right {
		display: flex;
		position: relative;
		align-items: center;
		justify-content: space-between;
		/* justify-content: space-between; */
		/* justify-content: space-between; */

		margin-bottom: 0.3rem;
	}

	.vangrid-bottom {
		padding-bottom: 0.6rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/pages/pages.vue